import ConfigStore from './config'
import Base from './base'

/** store --- */
const mainStore: { [key: string]: typeof Base } = {
  ConfigStore,
}

export default mainStore
